



export default theme =>({
    toggle:{
        height: 'min-content',
        width: 'min-content'
    }
})